import { render, staticRenderFns } from "./AssetFaultLog.vue?vue&type=template&id=90560bc2&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90560bc2",
  null
  
)

export default component.exports